export class TableRowSelection {
    constructor(public Data: any, public IsChecked: boolean) { }
}